import { createSelector } from 'reselect'
import { State } from 'index'

const navSelector = (state: State) => state.nav

export const getSubHeaderOpen = createSelector([navSelector], (state) => state.sub_header.open)
